/**
 * 懒加载 CSS 背景图指令 v-lazy-bg
 * 元素进入视口前不加载背景图，避免首屏大量图片阻塞主线程
 */
const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const el = entry.target
				const url = el.__lazyBgUrl
				if (url) {
					el.style.backgroundImage = `url(${url})`
					observer.unobserve(el)
					el.__lazyBgLoaded = true
				}
			}
		})
	}, {
		rootMargin: '300px'
	} // 提前 300px 开始加载
)

export default {
	inserted(el, binding) {
		const url = binding.value
		if (!url) return
		el.__lazyBgUrl = url
		el.__lazyBgLoaded = false
		observer.observe(el)
	},
	update(el, binding) {
		const url = binding.value
		if (url && url !== el.__lazyBgUrl) {
			el.__lazyBgUrl = url
			if (el.__lazyBgLoaded) {
				// URL 变了但已经加载过，直接更新
				el.style.backgroundImage = `url(${url})`
			}
			// 否则等 observer 回调再设置
		}
	},
	unbind(el) {
		observer.unobserve(el)
	}
}